import React from "react";
import "./styles/Registration.css";

function Registration() {
  return (
    <div className="button">
      <h3>S'INSCRIRE</h3>
    </div>
  );
}

export default Registration;
